import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';
import NotificationContext from '../NotificationContext';
import LoadingSpinner from './LoadingSpinner';

const TechnicianProfileForm = () => {
    const { user } = useContext(AuthContext);
    const { showNotification } = useContext(NotificationContext);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        address: '',
        pincode: '',
        servicesOffered: '',
        bio: '',
        hourlyRate: ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user || user.role !== 'technician') {
            navigate('/');
            return;
        }

        const fetchProfile = async () => {
            setLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }
            try {
                const res = await axios.get('https://local-technician-finder-backend.onrender.com/api/technicians/me', {
                    headers: { 'x-auth-token': token }
                });
                const profileData = res.data;
                setFormData({
                    firstName: profileData.firstName || '',
                    lastName: profileData.lastName || '',
                    phone: profileData.phone || '',
                    address: profileData.address || '',
                    pincode: profileData.pincode || '',
                    servicesOffered: profileData.servicesOffered ? profileData.servicesOffered.map(s => s.name).join(', ') : '',
                    bio: profileData.bio || '',
                    hourlyRate: profileData.hourlyRate || ''
                });
            } catch (err) {
                console.error('Error fetching existing profile (expected if new):', err);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [user, navigate]);

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) {
            showNotification('Please log in to manage your profile.', 'error');
            return;
        }

        const servicesArray = formData.servicesOffered.split(',').map(service => service.trim()).filter(service => service !== '');

        try {
            await axios.post('https://local-technician-finder-backend.onrender.com/api/technicians', { ...formData, servicesOffered: servicesArray }, {
                headers: {
                    'x-auth-token': token
                }
            });
            showNotification('Profile updated successfully!', 'success');
            navigate('/technicians/me');
        } catch (err) {
            console.error(err.response.data);
            showNotification(err.response.data.msg || 'Failed to update profile.', 'error');
        }
    };

    if (loading) return <LoadingSpinner />;

    return (
        <div className="form-container">
            <h1>{formData.firstName ? 'Edit Your Profile' : 'Create Your Profile'}</h1>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label className="form-label">First Name:</label>
                    <input type="text" name="firstName" value={formData.firstName} onChange={onChange} className="form-control" required />
                </div>
                <div className="form-group">
                    <label className="form-label">Last Name:</label>
                    <input type="text" name="lastName" value={formData.lastName} onChange={onChange} className="form-control" required />
                </div>
                <div className="form-group">
                    <label className="form-label">Phone:</label>
                    <input type="text" name="phone" value={formData.phone} onChange={onChange} className="form-control" />
                </div>
                <div className="form-group">
                    <label className="form-label">Address:</label>
                    <input type="text" name="address" value={formData.address} onChange={onChange} className="form-control" />
                </div>
                <div className="form-group">
                    <label className="form-label">Pincode:</label>
                    <input type="text" name="pincode" value={formData.pincode} onChange={onChange} maxLength="6" className="form-control" />
                </div>
                <div className="form-group">
                    <label className="form-label">Services Offered (comma-separated):</label>
                    <input type="text" name="servicesOffered" value={formData.servicesOffered} onChange={onChange} placeholder="e.g., Plumbing, Electrical, HVAC" className="form-control" />
                </div>
                <div className="form-group">
                    <label className="form-label">Bio:</label>
                    <textarea name="bio" value={formData.bio} onChange={onChange} maxLength="300" className="form-control"></textarea>
                </div>
                <div className="form-group">
                    <label className="form-label">Hourly Rate:</label>
                    <input type="number" name="hourlyRate" value={formData.hourlyRate} onChange={onChange} min="0" className="form-control" />
                </div>
                <input type="submit" value="Save Profile" className="btn" />
            </form>
        </div>
    );
};

export default TechnicianProfileForm;